import axios from 'axios';
import auth from '@/utils/auth';

import {
  DELETE_NOTICE,
  DELETE_NOTICE_ERROR,
  DELETE_NOTICE_SUCCESS,

  GET_NOTICE,
  GET_NOTICE_ERROR,
  GET_NOTICE_SUCCESS,

  GET_NOTICES,
  GET_NOTICES_ERROR,
  GET_NOTICES_SUCCESS,

  SAVE_NOTICE,
  SAVE_NOTICE_ERROR,
  SAVE_NOTICE_SUCCESS,

  CREATE_NOTICE,
  CREATE_NOTICE_ERROR,
  CREATE_NOTICE_SUCCESS,

  GET_RECURRENCY,
  GET_RECURRENCY_ERROR,
  GET_RECURRENCY_SUCCESS,

  SEND_MAILTO_USER,
  SEND_MAILTO_USER_SUCCESS,
  SEND_MAILTO_USER_ERROR,

  SEND_TO,
  SEND_TO_SUCCESS,
  SEND_TO_ERROR,

  GET_COOWNERS_FIELDS,
  GET_COOWNERS_FIELDS_ERROR,
  GET_COOWNERS_FIELDS_SUCCESS,

  GET_COOWNERS_USER,
  GET_COOWNERS_USER_ERROR,
  GET_COOWNERS_USER_SUCCESS,

  GET_CUSTOM_PLACEHOLDER,
  GET_CUSTOM_PLACEHOLDER_ERROR,
  GET_CUSTOM_PLACEHOLDER_SUCCESS,

  SEND_NOTICE,
  SEND_NOTICE_ERROR,
  SEND_NOTICE_SUCCESS,

} from './constants';

export default {
  async [DELETE_NOTICE]({ commit }, data) {
    try {
      commit(DELETE_NOTICE);
      const response = await axios({
        url: `${process.env.API_URL}/api/delete/multiple/notices`,
        method: 'DELETE',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(DELETE_NOTICE_SUCCESS, response.data);
    } catch (err) {
      commit(DELETE_NOTICE_ERROR, err);
    }
  },
  async [GET_NOTICE]({ commit }, noticeID) {
    try {
      commit(GET_NOTICE);
      const response = await axios({
        url: `${process.env.API_URL}/api/notices/${noticeID}`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_NOTICE_SUCCESS, response.data);
    } catch (err) {
      commit(GET_NOTICE_ERROR, err);
    }
  },

  async [GET_NOTICES]({ commit }, args) {
    try {
      commit(GET_NOTICES);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${args.syndicateID}/notices`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: {
          limit: args.limit || localStorage.pageLimit || '50',
          page: args.page || 0,
          sortField: args.sortField || 'title',
          sortDir: args.sortDir || 'ASC',
          filters: args.filters || null,
        },
      });
      commit(GET_NOTICES_SUCCESS, response.data);
    } catch (err) {
      commit(GET_NOTICES_ERROR, err);
    }
  },

  async [GET_RECURRENCY]({ commit }, data) {
    try {
      commit(GET_RECURRENCY);
      const response = await axios({
        url: `${process.env.API_URL}/api/notices/recurrency`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(GET_RECURRENCY_SUCCESS, response.data);
    } catch (err) {
      commit(GET_RECURRENCY_ERROR, err);
    }
  },

  async [GET_COOWNERS_FIELDS]({ commit }, data) {
    try {
      commit(GET_COOWNERS_FIELDS);
      const response = await axios({
        url: `${process.env.API_URL}/api/coowner/fields/${data}`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(GET_COOWNERS_FIELDS_SUCCESS, response.data);
    } catch (err) {
      commit(GET_COOWNERS_FIELDS_ERROR, err);
    }
  },

  async [GET_COOWNERS_USER]({ commit }, data) {
    try {
      commit(GET_COOWNERS_USER);
      const response = await axios({
        url: `${process.env.API_URL}/api/coowner/users/${data}`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(GET_COOWNERS_USER_SUCCESS, response.data);
    } catch (err) {
      commit(GET_COOWNERS_USER_ERROR, err);
    }
  },

  async [SAVE_NOTICE]({ commit }, data) {
    try {
      commit(SAVE_NOTICE);
      const response = await axios({
        url: `${process.env.API_URL}/api/notices/${data.noticeID}`,
        method: 'PUT',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(SAVE_NOTICE_SUCCESS, response.data);
    } catch (err) {
      commit(SAVE_NOTICE_ERROR, err);
    }
  },

  async [SEND_MAILTO_USER]({ commit }, data) {
    try {
      commit(SEND_MAILTO_USER);
      const response = await axios({
        url: `${process.env.API_URL}/api/send/notices/user/${data.noticeID}`,
        method: 'PUT',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(SEND_MAILTO_USER_SUCCESS, response.data);
    } catch (err) {
      commit(SEND_MAILTO_USER_ERROR, err);
    }
  },
  async [SEND_TO]({ commit }, noticeID) {
    try {
      commit(SEND_TO);
      const response = await axios({
        url: `${process.env.API_URL}/api/send/notices/${noticeID}`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(SEND_TO_SUCCESS, response.data);
    } catch (err) {
      commit(SEND_TO_ERROR, err);
    }
  },

  async [CREATE_NOTICE]({ commit }, data) {
    try {
      commit(CREATE_NOTICE);
      const response = await axios({
        url: `${process.env.API_URL}/api/notices`,
        method: 'POST',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(CREATE_NOTICE_SUCCESS, response.data);
    } catch (err) {
      commit(CREATE_NOTICE_ERROR, err);
    }
  },

  async [SEND_NOTICE]({ commit }, data) {
    try {
      commit(SEND_NOTICE);
      const response = await axios({
        url: `${process.env.API_URL}/api/send/notices`,
        method: 'POST',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(SEND_NOTICE_SUCCESS, response.data);
    } catch (err) {
      commit(SEND_NOTICE_ERROR, err);
    }
  },

  async [GET_CUSTOM_PLACEHOLDER]({ commit }, data) {
    try {
      commit(GET_CUSTOM_PLACEHOLDER);
      const response = await axios({
        url: `${process.env.API_URL}/api/coowner/notice/placeholder/${data.syndicateID}/${data.value}`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_CUSTOM_PLACEHOLDER_SUCCESS, response.data);
    } catch (err) {
      commit(GET_CUSTOM_PLACEHOLDER_ERROR, err);
    }
  },


};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Information/Notices/actions.js